import { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  Container,
  Row,
  Col,
  Button,
  Alert as Alert2,
  Spinner,
  Table,
} from "reactstrap";
import {
  CustomerInformation,
  CustomerInformation2,
  UnitInformation,
  ContractBuild,
  ContractPricing,
  Payment,
  ContractCrumbs,
} from "./";
import { Header, Footer, Loading } from "../";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import Alert from "react-s-alert-v3";
import { useParams, useHistory } from "react-router-dom";
import classnames from "classnames";
import { default as useContractStore } from "./utils/useContractStore";
import { default as useUserStore } from "../../hooks/useUserStore";
import { api, ui_helpers, date_helpers } from "../../helpers";
import { storage, constants } from "../../utils";
import { default as common } from "./utils/common";

const {
  PHASE_NAMES,
  QUOTE_PHASE_LIST,
  CONTRACT_BUILD_PHASE_LIST,
  CASH_SALE_BUILD_PHASE_LIST,
  CONTRACT_PHASE_LIST,
  CASH_SALE_PHASE_LIST,
} = common;

export default function ContractEdit({ contractType, convertFromQuote }) {
  const { routeContractId, fromInventoryId } = useParams();
  let contractId = useContractStore((x) => x.contractId);
  const {
    setContractId,
    setContractType,
    companyId,
    setCompanyId,
    dealerId,
    region,
    culture,
    setCulture,
    widthFeet,
    setWidthFeet,
    lengthFeet,
    setLengthFeet,
    heightFeet,
    setHeightFeet,
    heightFeetOtherText,
    employmentType,
    isQuote,
    setIsQuote,
    isRTO,
    setIsRTO,
    isCashSale,
    setIsCashSale,
    unitPrice,
    associatedBundles,
    addOns,
    lastPairedInventoryId,
    agreementNumber,
    setAgreementNumber,
    validationMessage,
    setValidationMessage,
    disableSale,
    otherSalesperson,
    setOtherSalesperson,
    salespeople,
    setSalespeople,
    wasInitialCreation,
    setWasInitialCreation,
    inventoryId,
    dealers,
    dealer,
    setDealers,
    setSkus,
    regions,
    sku,
    setSku,
    setRegions,
    setRegion,
    cultures,
    setCultures,
    productTypes,
    setProductTypes,
    baseColors,
    setBaseColors,
    trimColors,
    setTrimColors,
    roofColors,
    setRoofColors,
    roofColor,
    setRoofColor,
    trimColor,
    setTrimColor,
    baseColor,
    setBaseColor,
    otherBaseColor,
    setOtherBaseColor,
    otherTrimColor,
    setOtherTrimColor,
    otherRoofColor,
    setOtherRoofColor,
    subproductTypes,
    setSubproductTypes,
    salesperson,
    setSalesperson,
    widths,
    setWidths,
    lengths,
    setLengths,
    heights,
    setHeights,
    unitTypes,
    setUnitTypes,
    deliveryInstructions,
    paymentDueDayOfMonth,
    manufacturers,
    setManufacturers,
    setManufacturer,
    employmentTypes,
    setEmploymentTypes,
    setEmploymentType,
    setEmployerName,
    employerName,
    setEmployerPhone,
    employerPhone,
    employerEmail,
    propertyOwner,
    enableBuildFeature,
    optedOutOfDamageLiabilityWaiver,
    setEnableBuildFeature,
    enableCustomSerialGeneration,
    setEnableCustomSerialGeneration,
    priceAdjustments,
    setPriceAdjustments,
    balanceDue,
    setPaymentTypes,
    hideUnitType,
    setHideUnitType,
    ownershipCompanyList,
    setOwnershipCompanyList,
    setAutoShowEditor,
    quoteDownPayment,
    taxRate,
    setTaxRate,
    setTaxRateString,
    serialNumber,
    setSerialNumber,
    setCaptiveInventoryId,
    buildingOrientation,
    buildingOrientations,
    setBuildingOrientations,
    defaultUnitTypeId,
    setDefaultUnitTypeId,
    setDueDays,
    isPairing,
    setPendingPriceAdjustment,
    phaseName,
    setPhaseName,
    assessValidity,
    getWarnings,
    selectedTermInfo,
    manufacturerId,
    manufacturer,
    productType,
    setProductType,
    subproduct,
    setSubproduct,
    otherSubproduct,
    setOtherSubproduct,
    fieldWarnings,
    setFieldWarnings,
    unitType,
    setUnitType,
    unitTypeOtherText,
    setUnitTypeOtherText,
    unitIsInventory,
    setUnitIsInventory,
    pristineUnitIsNew,
    unitIsNew,
    setUnitIsNew,
    widthFeetOtherText,
    setWidthFeetOtherText,
    lengthFeetOtherText,
    setLengthFeetOtherText,
    additionalContactData,
    setAdditionalContactData,
    otherManufacturer,
    setContactCount,
    initialPaymentAmount,
    isTaxExempt,
    taxExemptionForm,
    initialize,
    unitOtherColorText,
    productTypeOtherText,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    customerPhone1,
    setCustomerPhone1,
    secondaryPhone,
    setSecondaryPhone,
    email,
    setEmail,
    ssn,
    setSsn,
    licenseNo,
    setLicenseNo,
    dateOfBirth,
    setDateOfBirth,
    deliveryName,
    deliveryAddress1,
    deliveryAddress2,
    deliveryCity,
    deliveryState,
    deliveryZip,
    deliveryCounty,
    billingName,
    setDeliveryCounty,
    billingAddress1,
    billingAddress2,
    billingCity,
    billingState,
    billingZip,
    promotionCodeTemp,
    isInCityLimits,
    landOwnerFirstName,
    landOwnerLastName,
    landOwnerAddress1,
    landOwnerAddress2,
    landOwnerCity,
    landOwnerState,
    landOwnerPhone,
    landOwnerZip,
    landOwnerEmail,
    corenterFirstName,
    corenterLastName,
    corenterAddress1,
    corenterAddress2,
    corenterCity,
    corenterState,
    corenterZip,
    corenterEmail,
    corenterPhone,
    corenterDateOfBirth,
    bundlesToDelete,
    typeOfContractStatus,
    setTypeOfContractStatus,
    loadedExistingManufacturerId,
    savedAddons,
    setSavedAddons,
    setDealer,
    setMaxInitialPaymentAmount,
    maxInitialPaymentAmount,
    contractTransferPayments,
    setContractTransferPayments,
    canSetRetained,
    setCanSetRetained,
    companyAcceptsPayment,
    setCompanyAcceptsPayment,
    setRtoTaxExemptionEnabled,
    estimatedDeliveryDate,
    isInitialLoad,
    setIsInitialLoad,
    reset,
    setAddOns,
    setAssociatedBundles,
  } = useContractStore();
  // console.log("current state", useContractStore.getState());
  const currentUser = useUserStore((x) => x.currentUser);
  const history = useHistory();
  const [completedInitialLoad, setCompletedInitialLoad] = useState(false);
  const [originalCompanyId, setOriginalCompanyId] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingContract, setLoadingContract] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [commentPrivate, setCommentPrivate] = useState(false);
  const [comments, setComments] = useState([]);
  const [phase, setPhase] = useState(null);
  const [phaseList, setPhaseList] = useState(resolvePhaseList());
  const [isSystemAdmin, setIsSystemAdmin] = useState(false);
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);
  const [isCompanyUser, setIsCompanyUser] = useState(false);
  const [canManageComments, setCanManageComments] = useState(false);
  const [currentUserHasContractCreatorRole, setCurrentUserHasContractCreatorRole] = useState(false);
  const [warningList, setWarningList] = useState([]);
  const [retrievedDealer, setRetrievedDealer] = useState({value: null, label: null});

  useEffect(() => {
    reset();
    setValidationMessage(null);
    setIsSystemAdmin(ui_helpers.isSystemAdministrator(currentUser));
    setIsRTO(contractType === constants.CONTRACT_TYPE.RTO);
    setIsCashSale(contractType === constants.CONTRACT_TYPE.CASH_SALE);
    setIsQuote(contractType === constants.CONTRACT_TYPE.QUOTE);
    initialLoad();
  }, []);

  useEffect(() => {
    if (!completedInitialLoad) return;
    if (completedInitialLoad && routeContractId) {
      loadContract(routeContractId, buildingOrientations);
    }
  }, [completedInitialLoad]);

  useEffect(() => {
    if (!completedInitialLoad && !retrievedDealer) return;
    if (retrievedDealer.value != null) {
      if (!_.some(dealers || [], (d) => d.value === retrievedDealer.value)) {
        setDealers([retrievedDealer, ...(dealers || [])]);
      }
    }
  }, [retrievedDealer, dealers]);

  useEffect(() => {
    if (loadingPage) return;
    const MFG_ROLES = [
      constants.ROLE_IDS.InventoryCreator,
      constants.ROLE_IDS.InventoryManager,
      constants.ROLE_IDS.Administrator,
    ];
    const DISPATCHER_ROLES = [constants.ROLE_IDS.Administrator, constants.ROLE_IDS.Dispatcher];
    const COMPANY_ROLES = [constants.ROLE_IDS.Administrator, constants.ROLE_IDS.ContractManager];

    setCanManageComments(isSystemAdmin || ui_helpers.canManageContracts(currentUser, companyId, dealerId) ||
      _.some(currentUser.roles,
        (ro) => ro.manufacturerId === manufacturerId && MFG_ROLES.includes(ro.typeOfUserRole))
      || _.some(currentUser.roles,
        (ro) =>
          ((ro.manufacturerId === manufacturerId || ro.companyId === companyId) &&
            DISPATCHER_ROLES.includes(ro.typeOfUserRole)) ||
          (ro.dealerId === dealerId && ro.typeOfUserRole === constants.ROLE_IDS.Dispatcher) ||
          (ro.companyId === companyId && ro.typeOfUserRole === constants.ROLE_IDS.Dispatcher))
      || ui_helpers.isStoreUser(currentUser, dealerId));
    setIsCompanyUser(ui_helpers.isContextCompanyUser(currentUser, companyId));
    setIsCompanyAdmin(_.some(currentUser.roles,
        (ro) => ro.companyId === companyId && COMPANY_ROLES.includes(ro.typeOfUserRole)));
    setCurrentUserHasContractCreatorRole(_.some(
      currentUser.roles, (ro) => ro.typeOfUserRole === constants.ROLE_IDS.ContractCreator));
  }, [loadingPage, companyId, dealerId, manufacturerId]);

  useEffect(() => {
    if (!dealerId || (dealerId === constants.ANY_ID && (!salesperson || salesperson.label !== constants.OTHER))) {
      setSalespeople([constants.OTHER_OPTION]);
      setSalesperson(constants.OTHER_OPTION);
    }
    else if (dealerId > 0) {
      api.fetch("contract/GetSalespeople/" + dealerId)
        .then((r) => {
          let newSalesList = r.data;
          if (_.some(newSalesList, (x) => x.label === constants.OTHER)) {
            const idx = _.findIndex(r.data, (x) => x.label === constants.OTHER);
            newSalesList[idx].value = constants.OTHER_ID;
          }
          if (!_.some(newSalesList, (x) => x.label === constants.OTHER)) {
            newSalesList.push(constants.OTHER_OPTION);
          }
          setSalespeople(newSalesList);
          let salespersonLabel =
            salesperson && salesperson.label !== constants.OTHER
              ? salesperson.label
              : otherSalesperson || "";
          let selectedPerson = _.find(newSalesList, (t) => t.label === salespersonLabel);
          if (!selectedPerson) {
            const lastSalespersonLabel = storage.getItem(
              constants.STORAGE_KEYS.LAST_SALESPERSON_LABEL
            );
            if (newSalesList && newSalesList.length && lastSalespersonLabel) {
              selectedPerson = _.find(newSalesList, (x) => x.label === lastSalespersonLabel);
            }
          }
          if (selectedPerson) {
            setSalesperson(selectedPerson);
            if (selectedPerson.label !== constants.OTHER) {
              setOtherSalesperson("");
            }
          } else {
            setSalesperson(constants.OTHER_OPTION);
          }
        })
        .catch((e) => console.error(e));
      if (isCashSale) {
        api.post("cashsale/GetOwnershipCompanyOptions/" + dealerId, {})
          .then((r) => {
            setOwnershipCompanyList(r.data);
          })
          .catch((e) => console.error(e));
      }
    }
  }, [dealerId]);

  function getSubProductOptions() {
    if (isPairing) return;
    if (
      !subproduct ||
      !subproduct.value ||
      subproduct.value === constants.OTHER_ID ||
      !productType ||
      (productType && productType.value < 0)
    ) {
      setSkus([constants.OTHER_OPTION]);
      setSku(constants.OTHER_OPTION);
      return;
    }

    api.fetch("contract/GetMfgSubProductSkuOptions/" + subproduct.value)
      .then((r) => {
        let list = _.chain(r.data)
          .sortBy(["width", "length"])
          .map((d) => ({ ...d, value: d.id, label: d.displayName }))
          .value();
        list.unshift(constants.OTHER_OPTION);
        setSkus(list);
        const live = useContractStore.getState();
        const selectedItem = live.sku
          ? _.find(list, (t) => t.value === live.sku.value)
          : _.find(list, (t) => t.width === live.widthFeet && t.length === live.lengthFeet);
        if (selectedItem) {
          setSku(selectedItem);
        } else {
          setSku(constants.OTHER_OPTION);
          setWidthFeetOtherText(live.widthFeetOtherText === "" ? live.widthFeet : live.widthFeetOtherText);
          setWidthFeet(constants.OTHER_ID);
          setLengthFeetOtherText(live.lengthFeetOtherText === "" ? live.lengthFeet : live.lengthFeetOtherText);
          setLengthFeet(constants.OTHER_ID);
        }
      })
      .then(() => {
        // reusing this same api to fetch colors for a specific subproduct; it's cached server-side
        if (manufacturerId && productType && productType.value) {
        api
          .fetch(
            `contract/GetManufacturerLists/${manufacturerId}/${productType.value}/${subproduct.value}`
          )
          .then((r) => {
            setColorLists(
              ui_helpers.idNameToValueLabel(r.data.baseColorList),
              ui_helpers.idNameToValueLabel(r.data.trimColorList),
              ui_helpers.idNameToValueLabel(r.data.roofColorList)
            );
          });
        }
      })
      .catch((err) => console.error("There was an issue fetching size options: " + err))
      .finally(() => {
        if (isInitialLoad) {
          setIsInitialLoad(false);
        }
      });
  }

  function setColorLists(baseList, trimList, roofList) {
    setBaseColors(baseList);
    setTrimColors(trimList);
    setRoofColors(roofList);
    const live = useContractStore.getState();
    let selectedItemText =
      live.roofColor && live.roofColor.label !== constants.OTHER ? live.roofColor.label : live.otherRoofColor;
    let selectedItem = _.find(roofList, (t) => t.label === selectedItemText);
    if (selectedItem) {
      setRoofColor(selectedItem);
      if (selectedItem.label !== constants.OTHER) {
        setOtherRoofColor("");
      }
    } else {
      setRoofColor(constants.OTHER_OPTION);
    }

    selectedItemText =
      live.trimColor && live.trimColor.label !== constants.OTHER ? live.trimColor.label : live.otherTrimColor;
    selectedItem = _.find(trimList, (t) => t.label === selectedItemText);
    if (selectedItem) {
      setTrimColor(selectedItem);
      if (selectedItem.label !== constants.OTHER) {
        setOtherTrimColor("");
      }
    } else {
      setTrimColor(constants.OTHER_OPTION);
    }

    selectedItemText =
      live.baseColor && live.baseColor.label !== constants.OTHER ? live.baseColor.label : live.otherBaseColor;
    selectedItem = _.find(baseList, (t) => t.label === selectedItemText);
    if (selectedItem) {
      setBaseColor(selectedItem);
      if (selectedItem.label !== constants.OTHER) {
        setOtherBaseColor("");
      }
    } else {
      setBaseColor(constants.OTHER_OPTION);
    }
  }

  // function resolveManufacturerId() {
  //   if (context.manufacturer && context.manufacturer.value) {
  //     return context.manufacturer.value;
  //   } else if (context.manufacturerBrandId) {
  //     return context.manufacturerBrandId;
  //   } else if (context.manufacturerId) {
  //     return context.manufacturerId;
  //   }
  //   return constants.OTHER_ID;
  // }

  function refreshManufacturerLists() {
    const { manufacturerId: liveManufacturerId, productType: liveProductType } = useContractStore.getState();
    api
      .fetch(`contract/GetManufacturerLists/${liveManufacturerId}/${liveProductType.value}`)
      .then((r) => {
        const live = useContractStore.getState();
        const changedUnitTypes = ui_helpers.idNameToValueLabel(r.data.unitTypeList, null, false);
        const changedSubproductTypes = ui_helpers.idNameToValueLabel(r.data.subproductTypeList);
        const changedBaseColors = ui_helpers.idNameToValueLabel(r.data.baseColorList, null, false);
        const changedTrimColors = ui_helpers.idNameToValueLabel(r.data.trimColorList, null, false);
        const changedRoofColors = ui_helpers.idNameToValueLabel(r.data.roofColorList, null, false);
        // if there is a subproduct allow the more specific call to load these lists
        if (!live.subproduct || live.subproduct.value === constants.OTHER_ID) {
          setColorLists(changedBaseColors, changedTrimColors, changedRoofColors);
        }
        setSubproductTypes(changedSubproductTypes);
        if (changedUnitTypes) {
          setUnitTypes(changedUnitTypes);
        }
        if (changedBaseColors) {
          setBaseColors(changedBaseColors);
        }
        if (changedTrimColors) {
          setTrimColors(changedTrimColors);
        }
        if (changedRoofColors) {
          setRoofColors(changedRoofColors);
        }
        if (r.data.defaultUnitTypeId) {
          setDefaultUnitTypeId(r.data.defaultUnitTypeId);
        }
        setHideUnitType(r.data.hideUnitType);
        // we only set this based on the manufacturing setting here
        // if it has not already been determined by an existing, saved relationship from a paired inventory
        if (!live.inventoryId && live.loadedExistingManufacturerId !== live.manufacturerId) {
          setEnableBuildFeature(r.data.enableBuildFeature);
        }
        setEnableCustomSerialGeneration(r.data.enableCustomSerialGeneration);
        let selectedItemText =
          live.subproduct && live.subproduct.label !== constants.OTHER ? live.subproduct.label : live.otherSubproduct;
        let selectedItem = _.find(changedSubproductTypes, (t) => t.label === selectedItemText);
        if (selectedItem) {
          setSubproduct(selectedItem);
          if (selectedItem.label !== constants.OTHER) {
            setOtherSubproduct("");
          }
        } else {
          setSubproduct(constants.OTHER_OPTION);
        }

        selectedItem = live.unitType && live.unitType.value && live.unitType.value !== constants.OTHER_ID
          ? _.find(changedUnitTypes, (t) => t.value === live.unitType.value)
          : null;
        if (!selectedItem) {
          selectedItemText =
            live.unitType && live.unitType.label !== constants.OTHER ? live.unitType.label : live.unitTypeOtherText;
          selectedItem = _.find(changedUnitTypes, (t) => t.label === selectedItemText);
        }
        if (selectedItem) {
          setUnitType(selectedItem);
          if (selectedItem.label !== constants.OTHER) {
            setUnitTypeOtherText("");
          }
        } else {
          setUnitType(constants.OTHER_OPTION);
        }

        // setSku(unitManufacturerSubProductSkuId
        //   ? { label: changedData.unitManufacturerSubProductSkuName, value: changedData.unitManufacturerSubProductSkuId}
        //   : changedData.subproductSku
        //     ? changedData.subproductSku
        //     : constants.OTHER_OPTION;
        let skuIsOther = live.sku && live.sku.value === constants.OTHER_ID;
        if (!live.sku) {
          setSku(constants.OTHER_OPTION);
          skuIsOther = true;
        }
        if (skuIsOther) {
          setWidthFeetOtherText(live.widthFeetOtherText === "" ? live.widthFeet : live.widthFeetOtherText);
          setLengthFeetOtherText(live.lengthFeetOtherText === "" ? live.lengthFeet : live.lengthFeetOtherText);
        }
        if (
          r.data.hideUnitType &&
          r.data.defaultUnitTypeId &&
          (!live.unitType || live.unitType.value !== r.data.defaultUnitTypeId) &&
          _.some(live.unitTypes, (ut) => ut.value === r.data.defaultUnitTypeId)
        ) {
          setUnitType(_.find(live.unitTypes, (ut) => ut.value === r.data.defaultUnitTypeId));
        }
        setPhaseList(resolvePhaseList());
      })
      .catch(api.catchHandler);
  }

  function onChangeMfgOrProductType(force = false) {
    if (!force && (loadingPage || loadingContract || isPairing)) return;
    const live = useContractStore.getState();
    if (!live.manufacturerId || !live.productType || !live.productType.value) {
      if (
        live.manufacturerId === constants.OTHER_ID &&
        (!live.productType || live.productType.value === constants.OTHER_ID)
      ) {
        setTrimColors([constants.OTHER_OPTION]);
        setBaseColors([constants.OTHER_OPTION]);
        setRoofColors([constants.OTHER_OPTION]);
        setRoofColor(constants.OTHER_OPTION);
        setTrimColor(constants.OTHER_OPTION);
        setBaseColor(constants.OTHER_OPTION);
        setSubproductTypes([constants.OTHER_OPTION]);
        setUnitTypes([constants.OTHER_OPTION]);
        setEnableBuildFeature(false);
        setEnableCustomSerialGeneration(false);
        setProductType(constants.OTHER_OPTION);
        setSubproduct(constants.OTHER_OPTION);
        setUnitType(constants.OTHER_OPTION);
        setSku(constants.OTHER_OPTION);
        setWidthFeetOtherText(live.widthFeetOtherText === "" ? live.widthFeet : live.widthFeetOtherText);
        setLengthFeetOtherText(live.lengthFeetOtherText === "" ? live.lengthFeet : live.lengthFeetOtherText);
      }
      return;
    }
    refreshManufacturerLists();
  }

  function initializeContactData(contacts = null) {
    let contactDataTemp = {};
    if (!contacts) contacts = [];
    const cnt = contacts.length > 2 ? contacts.length : 2;
    for (let i = 0; i < cnt; i++) {
      if (contacts.length > i && contacts[i].firstName) {
        contactDataTemp[`contact${i + 1}FirstName`] = contacts[i].firstName;
        contactDataTemp[`contact${i + 1}LastName`] = contacts[i].lastName;
        contactDataTemp[`contact${i + 1}Phone`] = contacts[i].phone;
        contactDataTemp[`contact${i + 1}Email`] = contacts[i].email;
        contactDataTemp[`contact${i + 1}Relationship`] = contacts[i].relationshipToCustomer;
      } else {
        contactDataTemp[`contact${i + 1}FirstName`] = "";
        contactDataTemp[`contact${i + 1}LastName`] = "";
        contactDataTemp[`contact${i + 1}Phone`] = "";
        contactDataTemp[`contact${i + 1}Email`] = "";
        contactDataTemp[`contact${i + 1}Relationship`] = "";
      }
    }
    setContactCount(cnt);
    setAdditionalContactData(contactDataTemp);
  }

  function loadContract(id = null, buildingOrientationList = null) {
    if (loadingContract) return;
    const cId = id ? id : contractId;
    if (!cId) return;
    setLoadingContract(true);
    let url = `${(contractType == constants.CONTRACT_TYPE.RTO ? "contract" : "cashSale")}/${cId}`;
    api.fetch(url)
      .then((r) => {
        if (!r.data.success) {
          setValidationMessage({ message: r.data.message, flavor: "danger" });
          setTimeout(() => setValidationMessage(null), 4000);
          return;
        }
        const c = r.data.message.contract;
        const newDealer = { value: c.dealerId, label: c.dealerName }; // c.dealerAbbr
        setRetrievedDealer(newDealer);
        let resolvedSubProduct = constants.OTHER_OPTION;
        if (c.unitManufacturerSubproductId) {
          resolvedSubProduct = {
            value: c.unitManufacturerSubproductId,
            label: c.unitManufacturerSubproductText,
          };
        }
        let resolvedSku = constants.OTHER_OPTION;
        if (c.skuId) {
          resolvedSku = { value: c.skuId, label: c.skuName };
        }
        const resolvedManufacturer = !c.manufacturerId
          ? constants.OTHER_OPTION
          : { value: c.manufacturerId, label: c.manufacturerName };

        /*
          additional fields provided:
            resolvedModelNumber,contractModelNumber,typeOfContractStatus,relatedUnitInventoryInvoiceNo,userHasPermissionsToRelatedInventory,
            firstAdditionalContactLastName,firstAdditionalContactFirstName,firstAdditionalContactRelationship,firstAdditionalContactPhone,
            customerEmployerAddress1,customerEmployerAddress2,customerEmployerCity,customerEmployerState,customerEmployerZip,isInCityLimits,
            contractTermMultiplier,contractTermName,milestoneStatus_Contract,milestoneStatus_Payment,milestoneStatus_LandlordPermission,
            milestoneStatus_Delivery,followupStatus_LoadedToRTO,followupStatus_CourtesyCall,followupStatus_OnHold,followupStatus_Commission,
            agreedPriceAt,taxRateId,taxZone,sumOfPriceAdjustments,sumOfAllAdjustments,sumOfSideFees,fromWeb,wcOrderId,sumOfPayments,
            sumOfPaymentsMinusCCFee,createdByUserId,createdAt,replicatedOutAt,assignedDriverUserFullName,assignedDriverUserId,confirmWarnings,
            deliveryTimeDisplay,customerSSNMaskedDisplay,totalTaxAmount,taxRateDisplay,standardTaxRate,standardTaxRateDisplay,effectiveTaxRateDisplay,
            hasUnseenComments,financedAmount,buildingDeliveredToGPSLatitude,buildingDeliveredToGPSLongitude,unitManufacturerSubProductSkuId,
            unitManufacturerSubProductSkuName,hasRecurringPaymentData,isAtLeast14FtWide,isAtLeast16FtWide,customerNote,isRTO,isQuote,
            lastSetCompleteAt,monthlyTaxAmount,totalMonthlyPayment,convertFromQuote,priceWithAddons,
            totalAddonPrice,basePrice,createdByUserName,existingWCOrder,promotionId,promotionName,downPaymentRequiredInExcessOfMax,
            regionAllowPurchaseReserve,driverLastAssignedAt,driverAssignedDaysAgo,resolvedWidthFeet,unitPriceWithPriceAdjustments,deliveredAt,deliveryTime,sac,
        */

        if (!buildingOrientationList) {
          buildingOrientationList = buildingOrientations;
        }

        initialize({
          contractId: cId,
          contractType: contractType,
          quoteDownPayment: c.quoteDownPayment,
          companyName: c.companyName,
          agreementNumber: c.agreementNumber,
          captiveInventoryId: c.captiveInventoryId,
          creditCardFeePercentage: c.creditCardFeePercentage,
          requiredPriceOverride: c.requiredPriceOverride,
          paperlessBillingEmail: c.paperlessBillingEmail,
          firstName: c.customerFirstName || "",
          lastName: c.customerLastName || "",
          customerPhone1: c.customerPhone1 || "",
          secondaryPhone: c.customerPhone2 || "",
          email: c.customerEmail || "",
          ssn: ui_helpers.formatSSNField(c.customerSSN) || "",
          licenseNo: c.customerLicenseNumber || "",
          dateOfBirth: ui_helpers.formatDateField(c.customerDateOfBirth) || "",
          dealer: newDealer,
          region: {
            value: c.regionId,
            label: c.regionName,
            abbr: c.regionAbbr,
          },
          culture: { value: c.cultureId, label: c.cultureName },
          deliveryName: c.deliveryName || "",
          deliveryAddress1: c.deliveryAddress1 || "",
          deliveryAddress2: c.deliveryAddress2 || "",
          deliveryCity: c.deliveryCity || "",
          deliveryState: c.deliveryState || "",
          deliveryZip: c.deliveryZip || "",
          deliveryCounty: c.deliveryCounty || "",
          billingName: c.billingName || "",
          billingAddress1: c.billingAddress1 || "",
          billingAddress2: c.billingAddress2 || "",
          billingCity: c.billingCity || "",
          billingState: c.billingState || "",
          billingZip: c.billingZip || "",
          companyId: c.companyId,
          propertyOwner: c.isPropertyOwner || false,
          mfgExpirationDate: c.mfgExpirationDate || date_helpers.addDays(90),
          landOwnerFirstName: c.landownerFirstName || "",
          landOwnerLastName: c.landownerLastName || "",
          landOwnerAddress1: c.landownerAddress1 || "",
          landOwnerAddress2: c.landownerAddress2 || "",
          landOwnerCity: c.landownerCity || "",
          landOwnerState: c.landownerState || "",
          landOwnerZip: c.landownerZip || "",
          landOwnerPhone: c.landownerPhone || "",
          landOwnerEmail: c.landownerEmail || "",
          employmentType: {
            value: c.customerEmploymentTypeId,
            label: c.customerEmploymentTypeName,
          },
          employerName: c.customerEmployerName || "",
          employerPhone: c.customerEmployerPhone || "",
          employerEmail: c.customerEmployerEmail || "",
          corenterFirstName: c.corenterFirstName || "",
          corenterLastName: c.corenterLastName || "",
          corenterAddress1: c.corenterAddress1 || "",
          corenterAddress2: c.corenterAddress2 || "",
          corenterCity: c.corenterCity || "",
          corenterState: c.corenterState || "",
          corenterZip: c.corenterZip || "",
          corenterDateOfBirth: c.corenterDateOfBirth || "",
          corenterPhone: c.corenterPhone || "",
          corenterEmail: c.corenterEmail || "",
          serialNumber: c.serialNumber,
          unitPrice: parseFloat(c.unitPrice || 0.0).toFixed(2),
          manufacturer: resolvedManufacturer,
          loadedExistingManufacturerId: resolvedManufacturer.value,
          otherManufacturer: c.manufacturerOtherText,
          productType: { value: c.productTypeId, label: c.productTypeName },
          productTypeOtherText: c.productTypeOtherText,
          inventoryId: c.inventoryId,
          widthFeet: c.unitWidthFeet,
          widthFeetOtherText: c.unitWidthFeetOtherText,
          lengthFeet: c.unitLengthFeet,
          lengthFeetOtherText: c.unitLengthFeetOtherText,
          heightFeet: c.unitHeightFeet,
          heightFeetOtherText: c.unitHeightFeetOtherText,
          unitIsNew: c.unitIsNew,
          pristineUnitIsNew: c.unitIsNew,
          buildingOrientation: c.deliveryBuildingOrientation
            ? _.find(buildingOrientationList, (b) => b.label === c.deliveryBuildingOrientation)
            : null,
          estimatedDeliveryDate: c.estimatedDeliveryDate ? moment(c.estimatedDeliveryDate) : "",
          salesperson: constants.OTHER_OPTION,
          otherSubproduct: c.unitManufacturerSubproductText,
          otherRoofColor: c.unitManufacturerRoofColorText,
          otherTrimColor: c.unitManufacturerTrimColorText,
          otherBaseColor: c.unitManufacturerBaseColorText,
          unitOtherColorText: c.unitOtherColorText,
          otherSalesperson:
            c.salespersonName === constants.OTHER
              ? ""
              : c.salespersonName || c.otherSalesperson || "",
          subproduct: resolvedSubProduct,
          sku: resolvedSku,
          unitType: c.unitTypeId != null ? { value: c.unitTypeId, label: c.unitTypeName } : null,
          unitTypeOtherText: c.unitTypeOtherText,
          baseColor: constants.OTHER_OPTION,
          roofColor: constants.OTHER_OPTION,
          trimColor: constants.OTHER_OPTION,
          deliveryInstructions: c.deliveryInstructions,
          unitIsInventory: c.soldFromInventory,
          addOns: c.contractAddOns,
          taxRateString: ui_helpers.taxRateStringFromTaxRate(c.taxRate || "0.000"),
          taxRate: c.taxRate || 0.0,
          isTaxExempt: c.isTaxExempt || false,
          taxExemptionForm: _.find(
            r.data.message.attachmentList,
            (a) => a.typeOfAttachment === constants.ATTACHMENT_TYPE_IDS.TaxExemptionForm
          ),
          damageLiabilityWaiverAmount: c.damageLiabilityWaiverAmount || 8.0,
          optedOutOfDamageLiabilityWaiver: c.optedOutOfDamageLiabilityWaiver || false,
          paymentDueDayOfMonth: c.paymentDueDayOfMonth || "5",
          initialPaymentAmount: parseFloat(c.initialPaymentAmount || 0.0).toFixed(2),
          includedInitialPayment: c.initialPaymentAmount ? true : false,
          creditCardSurcharge: c.creditCardSurcharge,
          selectedTermInfo: {
            //id: c.typeOfContractTerm,
            //typeOfContractTerm: c.typeOfContractTerm,
            monthlyPaymentAmount: c.monthlyPaymentAmount,
            contractTermId: c.contractTermId,
            dlwAmount: c.dlwAmount,
            minimumSecurityDepositAmount: c.minimumSecurityDepositAmount,
            dueForDeliveryAmount: c.dueForDeliveryAmount || 0.0, // requiredForDeliveryAmount,
            rentalCostAmount: c.rentalCostAmount, // c.totalRentalAmount,
            purchaseReserveAmount: c.purchaseReserveAmount,
          },
          promotionCode: c.promotionCode || "",
          promotionCodeTemp: c.promotionCode || "",
          enableRecurringPayments: c.enableRecurringPayments || false,
          associatedBundles: _.uniqBy(c.associatedBundles, "id"),
          bundlesToDelete: [],
          agreedPrice: c.agreedPrice,
          lastPairedInventoryId: 0,
          hideUnitType: c.mfgHideUnitTypeOption,
          balanceDue: c.balanceDue || 0.0,
          subtotal: c.balanceDue || 0.0,
          priceAdjustments: c.priceAdjustments,
          enableBuildFeature: c.existingBuildFeature,
          paymentList: r.data.message.paymentItems,
          cards: _.map(r.data.message.ccList, (cc) => ({
            value: cc.id,
            label: cc.secureDisplay,
          })),
          comments: r.data.message.commentList,
          ownershipCompanyList: r.data.message.ownershipCompanyList,
          attachmentList: r.data.message.attachmentList,
          companyEnableCreditCardPayments: c.companyEnableCreditCardPayments,
          typeOfPorch: c.typeOfPorch,
          porchMin: c.porchMin,
          porchMax: c.porchMax,
          porchWall1Length: c.porchWall1Length,
          porchWall2Length: c.porchWall2Length,
          porchWall3Length: c.porchWall3Length,
          porchWall4Length: c.porchWall4Length,
          porchColorId: c.porchColorId,
          porchColorName: c.porchColorName,
          fontSize: c.fontSize,
          rulerOffSet: c.rulerOffSet,
          typeOfContractStatus: c.typeOfContractStatus,
        });

        setSku(resolvedSku);
        initializeContactData(r.data.message.additionalContacts);
        setSavedAddons(r.data.message.unitOptionList);
        setMaxInitialPaymentAmount(c.maxInitialPaymentAmount);
        setContractTransferPayments(r.data.message.contractTransferPayments);
        setCanSetRetained(r.data.message.enableRetained);
        setRtoTaxExemptionEnabled(r.data.message.enableRTOTaxExemption);
        if (wasInitialCreation && contractType === constants.CONTRACT_TYPE.CASH_SALE) {
          // force intentional selection of companyid for cash sale initial load
          setOriginalCompanyId(c.companyId);
          setCompanyId(null);
        }
        onChangeMfgOrProductType(true);
        return { companyId: c.companyId, dealerId: c.dealerId };
      })
      .then(({ companyId, dealerId }) => {
        // refreshCompanyPaymentTypes
        let url = "contract/companyAcceptsPayment/" + companyId;
        if (dealerId && dealerId > 0) {
          url += "/" + dealerId;
        }
        api.post(url, {}).then((r) => {
          if (!r.data.success) {
            Alert.error("There was an error getting the payment types that this company accepts.");
            return;
          }
          setCompanyAcceptsPayment(r.data.message);
          let newPaymentTypes = constants.PAYMENT_TYPES.slice();
          if (!r.data.message.creditCards)
            _.remove(newPaymentTypes, { value: constants.PAYMENT_TYPE_IDS.CREDIT_CARD });
          if (!r.data.message.achBank)
            _.remove(newPaymentTypes, { value: constants.PAYMENT_TYPE_IDS.ACH_DEBIT });
          if (!isSystemAdmin && !isCompanyAdmin)
            _.remove(newPaymentTypes, { value: constants.PAYMENT_TYPE_IDS.COMMITMENT });
          // if (!isSystemAdmin && !r.data.message.enableRetained)
            _.remove(newPaymentTypes, { value: constants.PAYMENT_TYPE_IDS.RETAINED });
            _.remove(newPaymentTypes, {value: constants.PAYMENT_TYPE_IDS.MAIL});
          setPaymentTypes(newPaymentTypes);
        });
      })
      .catch((err) => {
        console.error(err);
        Alert.error("An error occurred while loading the contract. Please contact support.");
      })
      .finally(() => {
        setLoadingContract(false);
      });
  }

  function addPriceAdjustment(pa) {
    let payload = {
      contractId: contractId,
      description: pa.description,
      amount: pa.amount,
      includeInUnitPrice: pa.includeInUnitPrice,
    };
    if (pa.percentage && parseFloat(pa.percentage)) {
      const pct = parseFloat(pa.percentage);
      payload.percentage = pct / 100.0;
    }
    api
      .post("contract/addPriceAdjustment", payload)
      .then((r) => {
        if (r.data.success) {
          setPendingPriceAdjustment(null);
          setPriceAdjustments(r.data.message);
        } else {
          Alert.error(r.data.message);
        }
      })
      .catch((e) => console.error(e));
  }

  function deletePriceAdjustment(paId) {
    let payload = {
      contractId: contractId,
      priceAdjustmentId: paId,
    };
    api
      .post("contract/deletePriceAdjustment", payload)
      .then((r) => {
        if (r.data.success) {
          setPriceAdjustments(_.reject(priceAdjustments, (pa) => pa.id === paId));
        } else {
          Alert.error(r.data.message);
        }
      })
      .catch((e) => console.error(e));
  }

  function submitComment() {
    api.post("contract/addComment", {
      id: contractId,
      comment: comment,
      isPrivate: commentPrivate,
      isUrgent: commentUrgent
    }).then((r) => {
      if (r.data.success) {
        setComment("");
        setShowCommentModal(false);
        api.fetch(`contract/GetComments/${contractId}`).then((r) => setComments(r.data));
      } else {
        Alert.error(r.data.message);
      }
    })
    .catch((e) => console.error(e));
  }

  function deleteComment(commentId) {
    api
      .post("contract/deleteComment", { id: commentId })
      .then((r) => {
        if (r.data.success) {
          api.fetch(`contract/GetComments/${contractId}`).then((r) => setComments(r.data));
        } else {
          Alert.error(r.data.message);
        }
      })
      .catch((e) => console.error(e));
  }

  function resolvePhaseList() {
    if (isQuote) {
      return QUOTE_PHASE_LIST;
    } else if (enableBuildFeature && unitIsNew && !unitIsInventory) {
      return isRTO ? CONTRACT_BUILD_PHASE_LIST : CASH_SALE_BUILD_PHASE_LIST;
    } else if (isRTO) {
      return CONTRACT_PHASE_LIST;
    }
    return CASH_SALE_PHASE_LIST;
  }

  function createContract() {
    const lastMfgId = parseInt(storage.getItem(constants.STORAGE_KEYS.LAST_MFG_ID), 10);
    const lastRegionId = parseInt(storage.getItem(constants.STORAGE_KEYS.LAST_REGION_ID), 10);
    if (lastMfgId && _.some(manufacturers, (x) => x.value === lastMfgId)) {
      setManufacturer(_.find(manufacturers, (x) => x.value === lastMfgId));
    }
    if (!dealer && dealers.length) {
      setDealer(dealers[0]);
    }
    if (lastRegionId && !region && _.some(regions, (x) => x.value === lastRegionId)) {
      setRegion(_.find(regions, (r) => r.value === lastRegionId));
    }
    if (!employmentType && employmentTypes.length) {
      setEmploymentType(_.find(employmentTypes, (t) => t.label === "Employed"));
    }
    if (!culture) {
      setCulture(_.find(cultures, (c) => c.value === constants.CULTURE_ENGLISH_ID));
    }
    if (
      !productType &&
      productTypes.length &&
      _.some(productTypes, (x) => x.value === constants.PRODUCT_TYPE_IDS.STORAGE_BUILDING)
    ) {
      setProductType(
        _.find(productTypes, (t) => t.value === constants.PRODUCT_TYPE_IDS.STORAGE_BUILDING)
      );
    }
    if (!widthFeet) {
      setWidthFeet(6);
    }
    if (!lengthFeet) {
      setLengthFeet(8);
    }
    if (!associatedBundles) {
      setAssociatedBundles([]);
    }
    if (!addOns) {
      setAddOns([]);
    }
    const url = isRTO ? "contract/InitializeContract" : `cashSale/InitializeCashSale/${isQuote}`;
    api
      .post(url, { id: lastRegionId || 0 })
      .then((r) => {
        if (r.data.success) {
          const editUrl = isQuote
            ? constants.PATH_NAMES.QUOTE_EDIT
            : isRTO
            ? constants.PATH_NAMES.CONTRACT_EDIT
            : constants.PATH_NAMES.CASH_SALE_EDIT;
          history.push(editUrl + "/" + r.data.message.contractId);
          setContractId(r.data.message.contractId);
          setAgreementNumber(r.data.message.agreementNumber);
          setWasInitialCreation(true);
          loadContract(r.data.message.contractId);
        } else {
          setValidationMessage({ message: r.data.message, flavor: "warning" });
        }
      })
      .catch((err) => console.error(err));
  }

  function initialLoad() {
    setCompletedInitialLoad(false);
    if (loadingPage) return;
    setLoadingPage(true);
    setContractType(contractType);
    // purposely breaking the rules here to force synchronous recognition of the change
    if (routeContractId) {
      setContractId(routeContractId);
      // contractId = routeContractId;
    } else {
      setContractId(null); // mark this as a new contract creation
      // contractId = null;
    }
    api
      .fetch("contract/GetContractCreationData/" + contractType)
      .then((r) => ({
        dealerList: r.data.dealerList,
        regionList: r.data.regionList,
        cultureList: r.data.cultureList,
        widthList: r.data.widthList,
        heightList: r.data.heightList,
        productTypeList: r.data.productTypeList,
        dueDayList: r.data.dueDayList,
        buildingOrientationList: r.data.buildingOrientationList,
        manufacturerList: r.data.manufacturerList,
        employmentTypeList: r.data.employmentTypeList,
        lengthList: r.data.lengthList,
      }))
      .then(
        ({
          dealerList,
          defaultDealerId,
          regionList,
          cultureList,
          widthList,
          lengthList,
          heightList,
          dueDayList,
          productTypeList,
          employmentTypeList,
          buildingOrientationList,
          manufacturerList,
        }) => {
          setDealers(dealerList);
          if (
            defaultDealerId &&
            _.some(dealerList, (x) => x.value === defaultDealerId) &&
            !routeContractId
          ) {
            setDealer(_.find(dealerList, (x) => x.value === defaultDealerId));
          }
          setProductTypes(
            _.map(productTypeList, (pt) => ({
              ...pt,
              value: pt.productTypeId,
              label: pt.productTypeName,
            }))
          );
          setRegions(ui_helpers.idNameToValueLabel(regionList));
          setDueDays(ui_helpers.idNameToValueLabel(dueDayList, null, false));
          setCultures(cultureList);
          setWidths(widthList);
          setLengths(lengthList);
          setHeights(_.reject(heightList, (o) => !o.label));
          setEmploymentTypes(employmentTypeList);
          buildingOrientationList = _.reject(buildingOrientationList, (o) => !o.label);
          setBuildingOrientations(buildingOrientationList);
          manufacturerList.unshift(constants.OTHER_OPTION);
          setManufacturers(manufacturerList);
          setPhase(0);
          if (!routeContractId) {
            createContract();
          }
        }
      )
      .catch((e) => console.error(e))
      .finally(() => {
        setLoadingPage(false);
        setCompletedInitialLoad(true);
      });
  }

  useEffect(() => {
    if (!dealerId || isPairing || loadingPage) return;
    if (manufacturerId === constants.OTHER_ID) {
      const fullList = _.reject(
        constants.PRODUCT_TYPES,
        (x) => x.value === constants.SELECT_OPTION_ID
      );
      if (productTypes.length !== fullList.length) {
        setProductTypes(fullList);
      }
      if (!productType) {
        setProductType(constants.OTHER_OPTION);
      }
      return;
    } else if (!manufacturerId) {
      return;
    }
    api
      .fetch(`contract/getFilteredProductTypes/${manufacturerId}`)
      .then((r) => {
        if (r.data.success && r.data.message && r.data.message.length) {
          let list = ui_helpers.idNameToValueLabel(r.data.message, null, false);
          setProductTypes(list);
          if (productType && !_.some(list, (x) => x.value === productType.value)) {
            setProductType(constants.OTHER_OPTION);
          }
        }
      })
      .catch(api.catchHandler);
  }, [loadingPage, manufacturerId]);

  useEffect(() => {
    if (!loadingPage && manufacturerId && productType) {
      onChangeMfgOrProductType();
    }
  }, [loadingPage, manufacturer, productType]);

  useEffect(() => {
    // if the quote is a new version, do not set unitIsNew or unitIsInventory to null
    if (wasInitialCreation && !inventoryId) {
      // always force selection for these 2 fields upon initial creation
      setUnitIsNew(null);
      setUnitIsInventory(null);
    }
  }, [manufacturer]);

  useEffect(() => {
    if (!completedInitialLoad) return;
    if (loadingPage) return;
    getSubProductOptions();
  }, [subproduct]);

  useEffect(() => {
    if (!completedInitialLoad) return;
    setPhaseList(resolvePhaseList());
  }, [contractType, enableBuildFeature, unitIsInventory, unitIsNew, completedInitialLoad]);

  useEffect(() => {
    setPhaseName(phaseList[phase]);
  }, [phase]);

  function onDeleteSalesperson() {
    if (!salesperson) return;
    confirmAlert({
      title: "Confirm Deletion",
      message: `Are you sure you wish to delete ${salesperson.label}?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api
              .post("contract/DeleteSalesperson", { id: salesperson.value })
              .then((r) => {
                setSalesperson(null);
                setSalespeople(_.reject(salespeople, (p) => p.value === salesperson.value));
              })
              .catch((e) => console.error(e));
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  function getCustomerPayload() {
    let payload = {
      typeOfContractStatus: isQuote ? constants.CONTRACT_STATUS_ID.Quote : typeOfContractStatus,
      //   : constants.CONTRACT_STATUS_ID.Draft,
      companyId: companyId,
      convertFromQuote: convertFromQuote ? true : false,
      contractId: contractId,
      dealerId: dealer.value,
      regionId: parseInt(region.value, 10),
      regionAbbr: region.abbr,
      cultureId: culture.value,
      customerFirstName: firstName,
      customerLastName: lastName,
      customerPhone1: customerPhone1,
      customerPhone2: secondaryPhone,
      customerEmail: email,
      customerSSN: ssn,
      customerLicenseNumber: licenseNo,
      customerDateOfBirth: dateOfBirth,
      unitIsNew: unitIsNew,
      deliveryName: deliveryName,
      deliveryAddress1: deliveryAddress1,
      deliveryAddress2: deliveryAddress2,
      deliveryCity: deliveryCity,
      deliveryState: deliveryState,
      deliveryZip: deliveryZip,
      deliveryCounty: deliveryCounty,
      billingName: billingName,
      billingAddress1: billingAddress1,
      billingAddress2: billingAddress2,
      billingCity: billingCity,
      billingState: billingState,
      billingZip: billingZip,
      isInCityLimits: isInCityLimits,
      taxRate: taxRate,
    };
    if (payload.unitIsNew === null) {
      payload.unitIsNew = pristineUnitIsNew;
    }
    if (
      !isRTO &&
      !isQuote &&
      !companyId &&
      ownershipCompanyList &&
      ownershipCompanyList.length === 1
    ) {
      payload.companyId = ownershipCompanyList[0].id;
      // keep our state in sync with what is actually saved, otherwise returning
      // to this step shows no company selected and re-clears it on the next save
      setCompanyId(payload.companyId);
    }
    return payload;
  }

  function getCustomerRelationsPayload() {
    let payload = {
      contractId: contractId,
      customerEmploymentTypeId: employmentType.value,
      customerEmployerName: employerName,
      customerEmployerPhone: employerPhone,
      customerEmployerEmail: employerEmail,
      isPropertyOwner: propertyOwner,
      unitIsNew: unitIsNew,
      // these fields are no longer visible in the UI:
      // customerEmployerAddress1: customerEmployerAddress1,
      // customerEmployerAddress2: customerEmployerAddress2,
      // customerEmployerCity: customerEmployerCity,
      // customerEmployerState: customerEmployerState,
      // customerEmployerZip: customerEmployerZip,
      landownerFirstName: landOwnerFirstName,
      landownerLastName: landOwnerLastName,
      landownerAddress1: landOwnerAddress1,
      landownerAddress2: landOwnerAddress2,
      landownerCity: landOwnerCity,
      landownerState: landOwnerState,
      landownerPhone: landOwnerPhone,
      landownerZip: landOwnerZip,
      landownerEmail: landOwnerEmail,
      corenterFirstName: corenterFirstName,
      corenterLastName: corenterLastName,
      corenterAddress1: corenterAddress1,
      corenterAddress2: corenterAddress2,
      corenterCity: corenterCity,
      corenterState: corenterState,
      corenterZip: corenterZip,
      corenterEmail: corenterEmail,
      corenterPhone: corenterPhone,
      corenterDateOfBirth: corenterDateOfBirth,
    };
    if (payload.unitIsNew === null) {
      payload.unitIsNew = pristineUnitIsNew;
    }
    payload = { contract: payload, additionalContactList: [] };
    for (let i = 1; i <= 5; i++) {
      if (additionalContactData[`contact${i}FirstName`]) {
        payload.additionalContactList.push({
          id: 0,
          seq: i,
          firstName: additionalContactData[`contact${i}FirstName`],
          lastName: additionalContactData[`contact${i}LastName`],
          phone: additionalContactData[`contact${i}Phone`],
          email: additionalContactData[`contact${i}Email`],
          relationshipToCustomer: additionalContactData[`contact${i}Relationship`],
        });
      } else {
        break;
      }
    }
    delete payload.contract.contractAddOns;
    return payload;
  }

  function resolveSalespersonName() {
    return !salesperson || salesperson.label === constants.OTHER
      ? otherSalesperson
      : salesperson.label;
  }

  function getUnitInformationPayload() {
    let payload = {
      serialNumber:
        !serialNumber || (enableCustomSerialGeneration && serialNumber === "")
          ? "TBD"
          : _.trim(serialNumber),
      contractId: contractId,
      convertFromQuote: convertFromQuote ? true : false,
      manufacturerId: manufacturerId,
      manufacturerOtherText: otherManufacturer,
      unitIsNew: unitIsNew,
      unitPrice: unitPrice,
      customerPhone1: customerPhone1,
      deliveryName: deliveryName,
      deliveryAddress1: deliveryAddress1,
      deliveryAddress2: deliveryAddress2,
      deliveryCity: deliveryCity,
      deliveryState: deliveryState,
      deliveryZip: deliveryZip,
      deliveryCounty: deliveryCounty,
      deliveryInstructions: deliveryInstructions,
      deliveryBuildingOrientation:
        buildingOrientation && buildingOrientation.label
          ? buildingOrientation.label
          : buildingOrientation,
      mfgHideUnitTypeOption: hideUnitType,
      unitTypeId: hideUnitType ? defaultUnitTypeId : unitType ? unitType.value : constants.OTHER_ID,
      unitTypeOtherText: unitTypeOtherText,
      dealerId: dealer.value,
      unitOtherColorText: unitOtherColorText,
      productTypeId: productType ? productType.value : constants.OTHER_ID,
      productTypeOtherText: productTypeOtherText,
      unitManufacturerBaseColorText:
        baseColor && baseColor.label !== constants.OTHER ? baseColor.label : otherBaseColor,
      unitManufacturerTrimColorText:
        trimColor && trimColor.label !== constants.OTHER ? trimColor.label : otherTrimColor,
      unitManufacturerRoofColorText:
        roofColor && roofColor.label !== constants.OTHER ? roofColor.label : otherRoofColor,
      skuId: sku ? sku.value : constants.OTHER_ID,
      unitManufacturerSubproductId: subproduct ? subproduct.value : constants.OTHER_ID,
      unitManufacturerSubproductText:
        subproduct && subproduct.label !== constants.OTHER ? subproduct.label : otherSubproduct,
      soldFromInventory: unitIsInventory,
      companyId: companyId, // this value is determined and overridden server-side
      salespersonName: resolveSalespersonName(),
      bundlesToDelete: bundlesToDelete || [],
      contractAddOns: addOns,
      estimatedDeliveryDate: estimatedDeliveryDate
    };
    const isOtherSku = payload.skuId === constants.OTHER_ID;
    if (isOtherSku || !widthFeet) {
      payload.unitWidthFeet = null;
      payload.unitWidthFeetOtherText = widthFeetOtherText;
    } else {
      payload.unitWidthFeet = widthFeet;
      payload.unitWidthFeetOtherText = null;
    }
    if (isOtherSku || !lengthFeet) {
      payload.unitLengthFeet = null;
      payload.unitLengthFeetOtherText = lengthFeetOtherText;
    } else {
      payload.unitLengthFeet = lengthFeet;
      payload.unitLengthFeetOtherText = null;
    }
    if (isOtherSku || !heightFeet || heightFeet === constants.OTHER_ID) {
      payload.unitHeightFeet = null;
      payload.unitHeightFeetOtherText = heightFeetOtherText;
    } else {
      payload.unitHeightFeet = heightFeet;
      payload.unitHeightFeetOtherText = null;
    }
    if (isQuote) {
      const qdp = parseFloat(quoteDownPayment);
      if (qdp >= 0.0) {
        payload.quoteDownPayment = qdp;
      }
      // must smuggle this along for quotes since it is not saved to the model
      payload.inventoryId = fromInventoryId ? fromInventoryId : null;
    }
    if (lastPairedInventoryId) {
      payload.inventoryId = lastPairedInventoryId;
    }
    return payload;
  }

  function getPricingPayload() {
    return {
      contract: {
        // estimatedDeliveryDate: estimatedDeliveryDate,
        // priceWithAdjustments,
        //maxInitialPaymentAmount,
        agreementNumber: agreementNumber,
        paymentDueDayOfMonth: paymentDueDayOfMonth,
        optedOutOfDamageLiabilityWaiver: optedOutOfDamageLiabilityWaiver,
        salespersonName: resolveSalespersonName(),
        unitPrice: unitPrice,
        dueForDeliveryAmount:
          selectedTermInfo.requiredForDeliveryAmount_NOPR + ui_helpers.sideFeeSum(priceAdjustments),
        rentalCostAmount: selectedTermInfo.totalRentalAmount,
        purchaseReserveAmount: selectedTermInfo.purchaseReserveAmount,
        contractTermId: selectedTermInfo.contractTermId,
        damageLiabilityWaiverAmount: selectedTermInfo.dlwAmount,
        minimumSecurityDepositAmount: selectedTermInfo.minimumSecurityDepositAmount,
        contractId: contractId,
        monthlyPaymentAmount: selectedTermInfo.monthlyPaymentAmount,
        initialPaymentAmount: initialPaymentAmount,
        isTaxExempt: isTaxExempt,
        taxRate: isTaxExempt ? 0.0 : taxRate,
        deliveryCounty: deliveryCounty,
        isInCityLimits: isInCityLimits,
      },
      additionalContactList: [],
      promotionCode: promotionCodeTemp || "",
      priceOverrideCode: "",
    };
  }

  function getPaymentPayload() {
    if (isRTO) {
      return {
        contractId: contractId,
        skuId: sku ? sku.value : constants.OTHER_ID,
      };
    }
    return {
      contractId: contractId,
      skuId: sku ? sku.value : constants.OTHER_ID,
      unitPrice: unitPrice,
      dueForDeliveryAmount: balanceDue,
      taxRate: isTaxExempt ? 0.0 : taxRate,
      deliveryCounty: deliveryCounty,
      isInCityLimits: isInCityLimits,
      isTaxExempt: isTaxExempt,
    };
  }

  function prepareSavePayload() {
    let payload = null;
    let url = "";
    switch (phaseName) {
      case PHASE_NAMES.CUSTOMER:
        payload = getCustomerPayload();
        url = isRTO ? "contract/SaveCustomerA" : "cashSale/SaveCustomerA";
        break;
      case PHASE_NAMES.RELATIONS:
        payload = getCustomerRelationsPayload();
        url = "contract/SaveCustomerB";
        break;
      case PHASE_NAMES.UNITS:
        payload = getUnitInformationPayload();
        if (isQuote) {
          url = "CashSale/SaveQuote";
        } else if (isRTO) {
          url = "Contract/SaveUnit";
        } else {
          url = "CashSale/SaveUnit";
        }
        break;
      case PHASE_NAMES.BUILD:
        payload = {
          // TODO: add fields appropriate to this api
          contractId: contractId,
        };
        url = "contract/GenerateConditionalBuildSteps";
        break;
      case PHASE_NAMES.PRICING:
        payload = getPricingPayload();
        url = "contract/SavePricing";
        break;
      case PHASE_NAMES.PAYMENT:
        payload = getPaymentPayload();
        url = isRTO ? "contract/SavePayment" : "cashSale/SaveCashSaleBalance";
        break;
    }
    if (payload.contractAddOns && payload.contractAddOns.length) {
      _.each(payload.contractAddOns, (x) => {
        if (!x.length) {
          x.length = 0.0;
        }
        if (!x.width) {
          x.width = 0.0;
        }
      });
    }
    return { url, payload };
  }

  function saveContract(onSilentSaveCallback = null) {
    if (saving) return;
    assessValidity();
    const warnList = getWarnings().warnings;
    setWarningList(warnList);
    if (warnList.length) {
      setValidationMessage({
        message:
          "Please address the highlighted validation errors. Hover over a field to see error details.",
        flavor: "warning",
      });
      return;
    }
    if (loadingPage || loadingContract || saving) return;
    setSaving(true);
    const { url, payload } = prepareSavePayload();
    api.post(url, payload).then((r) => {
        if (!r.data) return;
        if (onSilentSaveCallback && typeof onSilentSaveCallback === "function") {
          onSilentSaveCallback();
          return;
        }
        if (r.data.success) {
          if (phase === 0) {
            if (r.data.success && r.data.message && r.data.message.taxSales) {
              setTaxRate(r.data.message.taxSales);
              setDeliveryCounty(r.data.message.geoCounty);
            } else {
              setTaxRate(0.0);
              setDeliveryCounty("");
            }
          } else if (phaseName === PHASE_NAMES.UNITS && r.data.message) {
            if (wasInitialCreation && !inventoryId) {
              setAutoShowEditor(true);
            }
            setTaxRate(r.data.message.taxRate);
            setSerialNumber(r.data.message.serialNumber);
            setCaptiveInventoryId(r.data.message.captiveInventoryId);
            setEnableBuildFeature(r.data.message.existingBuildFeature);
          } else if (phaseList[phase] === PHASE_NAMES.PRICING && !_.isNil(taxExemptionForm?.file)) {
            uploadTaxExemptionForm();
          }
          if (phase === phaseList.length - 1) {
            if (phaseName === PHASE_NAMES.PAYMENT && !_.isNil(taxExemptionForm?.file) && !isRTO) {
              uploadTaxExemptionForm();
            }
            history.push(
              isQuote
                ? `${constants.PATH_NAMES.QUOTE_VIEW}/${contractId}/essentials`
                : isRTO
                ? `${constants.PATH_NAMES.CONTRACT_VIEW}/${contractId}/essentials`
                : `${constants.PATH_NAMES.CASH_SALE_VIEW}/${contractId}/essentials`
            );
          } else {
            setFieldWarnings([]);
            setValidationMessage(null);
            setPhase(phase + 1);
          }
        } else if (
          typeof r.data.message === "object" &&
          r.data.message !== null &&
          r.data.message.code
        ) {
          if (r.data.message.message.includes("Phone Number")) {
            setValidationMessage({
              message: "Please address the validation error below.",
              flavor: "warning",
            });
            setFieldWarnings([
              {
                text: "Invalid customer phone number! Unable to notify customer of build step changes.",
                field: "customerPhone1",
              },
            ]);
          } else if (r.data.messsage.message != null) {
            setValidationMessage({
              message: r.data.message.message || "An unknown error occurred.",
              flavor: "warning",
            });
          }
        } else if (typeof r.data.message === "object" && r.data.message !== null) {
          // {fieldName: {message, uifieldid, severity}} -> [{text: 'warning', field: 'fieldName'}]
          const serverWarnings = _.map(_.keys(r.data.message), (fieldName) => ({
            field:
              _.find(constants.UNITPRICE_SEVERITIY_FIELD_NAMES, (f) => {
                return f === fieldName;
              }) !== undefined
                ? constants.severityUnitPrice
                : _.find(constants.INIT_PAYMENT_SEVERITIY_FIELD_NAMES, (f) => {
                    return f === fieldName;
                  }) !== undefined
                ? constants.severityInitPayment
                : fieldName,
            text: r.data.message[fieldName].message,
          }));
          setFieldWarnings(serverWarnings);
          setValidationMessage({
            message:
              "Please address the highlighted validation errors. Hover over a field to see error details.",
            flavor: "warning",
          });
        } else if (r.data.message) {
          setValidationMessage({
            message: r.data.message || "An unknown error occurred.",
            flavor: "warning",
          });
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setSaving(false));
  }

  function toTaxRateString(r) {
    return (r * 100.0).toFixed(3);
  }

  function uploadTaxExemptionForm() {
    let tForm = { ...taxExemptionForm };
    let formData = new FormData();
    formData.append("referenceId", contractId);
    formData.append("file", tForm.file);
    formData.append("typeOfAttachment", constants.ATTACHMENT_TYPE_IDS.TaxExemptionForm);
    api
      .post_form_data("contract/UploadTaxExemptionForm", formData)
      .then((res) => {
        if (!res || !res.data) return;
        if (!res.data.success) {
          Alert.error("There was an issue uploading the Tax exemption form.");
        }
      })
      .catch(api.catchHandler);
  }

  function findCustomer(probeSSN = "", probeLicenseNo = "") {
    if (_.trim(probeSSN) === "" && _.trim(probeLicenseNo) === "") {
      setValidationMessage({ message: "First enter a value to look up.", flavor: "warning" });
      setTimeout(() => setValidationMessage(null), 4000);
      return;
    }
    probeSSN = probeSSN.replace(/[-]/g, "");
    probeLicenseNo = probeLicenseNo.replace(/[-]/g, "");
    api
      .post("contract/FindCustomer", {
        ssn: probeSSN,
        licenseNo: probeLicenseNo,
      })
      .then((r) => {
        if (r.data.success) {
          setFirstName(r.data.message.firstName);
          setLastName(r.data.message.lastName);
          setCustomerPhone1(r.data.message.phone1);
          setSecondaryPhone(r.data.message.phone2);
          setEmail(r.data.message.email);
          setLicenseNo(r.data.message.licenseNumber);
          setDateOfBirth(r.data.message.dateOfBirthString);
          setEmploymentType(
            _.find(employmentTypes, (t) => t.value === r.data.message.employmentTypeId)
          );
          setEmployerName(r.data.message.employerName);
          setEmployerPhone(r.data.message.employerPhone);
        } else {
          setValidationMessage({ message: r.data.message, flavor: "warning" });
          setTimeout(() => setValidationMessage(null), 4000);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function onExitClick() {
    if (isQuote) {
      // save quote silently before redirecting
      saveContract(() => {
        reset();
        history.push(`${constants.PATH_NAMES.QUOTE_VIEW}/${contractId}/essentials`);
      });
    } else {
      reset();
      history.push(
        isRTO
          ? `${constants.PATH_NAMES.CONTRACT_VIEW}/${contractId}/essentials`
          : `${constants.PATH_NAMES.CASH_SALE_VIEW}/${contractId}/essentials`
      );
    }
  }

  const crumbs = useMemo(() => {
    if (!completedInitialLoad) return null;
    return (
      <ContractCrumbs
        currentPhase={phase}
        phaseList={phaseList}
        onSetPhase={(newPhaseIndex) => setPhase(newPhaseIndex)}
        isCompanyAdmin={isCompanyAdmin}
        isSystemAdmin={isSystemAdmin}
        currentUserHasContractCreatorRole={currentUserHasContractCreatorRole}
      />
    );
  }, [phase, phaseList, completedInitialLoad]);

  return (
    <div>
      <Header agreementNumber={agreementNumber} />
      <div className="p-2">
        <Container fluid>
          <Row className="mt-1" style={{ borderBottom: "solid 1px #999" }}>
            <Col xs={2}>
              <div className="header-text text-nowrap">{phaseName}</div>
            </Col>
            <Col xs={1} className={"d-flex align-items-center justify-content-start"}>
              {loadingPage || loadingContract ? <Spinner size="sm" /> : null}
            </Col>
            <Col xs={8}>{crumbs}</Col>
            <Col xs={1}>
              <Button
                color="dark"
                size="sm"
                className="float-end"
                onClick={onExitClick}
                style={{ width: "120px", fontWeight: "bold" }}>
                {loadingPage || loadingContract ? (
                  <Spinner animation="border" size={"sm"} />
                ) : (
                  "Exit"
                )}
              </Button>
            </Col>
          </Row>
          {loadingPage || loadingContract ? <Loading /> : null}
          {validationMessage ? (
            <Row>
              <Col sm="12">
                <Alert2
                  color={validationMessage.flavor} //"warning"
                  className={classnames({ invalid: fieldWarnings.length || warningList.length })}>
                  {validationMessage.message}{" "}
                  <FontAwesomeIcon icon="exclamation-circle" id="validationM" />
                  {fieldWarnings.length ? (
                    <div style={{ fontWeight: "normal" }}>
                      {fieldWarnings.map((x) => x.text).join(", ")}
                    </div>
                  ) : warningList.length ? (
                    <div style={{ fontWeight: "normal" }}>
                      {warningList.map((x) => x.text).join(", ")}
                    </div>
                  ) : null}
                </Alert2>
              </Col>
            </Row>
          ) : null}
          {phaseName === PHASE_NAMES.CUSTOMER ? (
            <CustomerInformation onFindCustomer={findCustomer} />
          ) : null}
          {phaseName === PHASE_NAMES.RELATIONS ? <CustomerInformation2 /> : null}
          {phaseName === PHASE_NAMES.UNITS ? (
            <UnitInformation
              onDeleteSalesperson={onDeleteSalesperson}
              // setIsPairing={(newValue) => {
              //   if (!newValue) {
              //     setSearchingUnpaired(false);
              //   }
              //   setIsPairing(newValue);
              // }}
              convertFromQuote={convertFromQuote}
              addPriceAdjustment={addPriceAdjustment}
              deletePriceAdjustment={deletePriceAdjustment}
            />
          ) : null}
          {phaseName === PHASE_NAMES.BUILD ? (
            <ContractBuild
              contractId={contractId}
              inventoryId={inventoryId}
              subProductId={subproduct && subproduct.value}
              // subProductSkuId={unitManufacturerSubProductSkuId}
              // subProductSkuName={unitManufacturerSubProductSkuName}
              onSaveContract={saveContract}
            />
          ) : null}
          {phaseName === PHASE_NAMES.PRICING ? (
            <ContractPricing
              addPriceAdjustment={addPriceAdjustment}
              deletePriceAdjustment={deletePriceAdjustment}
              onDeleteSalesperson={onDeleteSalesperson}
            />
          ) : null}
          {phaseList[phase] === PHASE_NAMES.PAYMENT ? (
            <Payment
              unitPriceDisabled // 06-Jun-24, ART, Conrad says this should always be disabled on this screen
              addPriceAdjustment={addPriceAdjustment}
              deletePriceAdjustment={deletePriceAdjustment}
              companyId={companyId || originalCompanyId}
              onSaveContract={saveContract}
            />
          ) : null}
          <Row style={{ borderTop: "solid 1px #999" }}>
            <div className="d-flex justify-content-between pt-1 pb-5">
              <div>
                {phase > 0 ? (
                  <Button
                    size="lg"
                    color="dark"
                    className="ms-2"
                    onClick={() => setPhase((p) => p - 1)}>
                    <FontAwesomeIcon icon="angle-left" className="me-2" />
                    Back
                  </Button>
                ) : null}
              </div>
              {phase === phaseList.length - 1 ? null : (
                <Button size="lg" color="dark" onClick={saveContract}>
                  {loadingPage || loadingContract || saving ? (
                    <Spinner animation="border" size={"sm"} />
                  ) : (
                    "Next"
                  )}
                  <FontAwesomeIcon icon="angle-right" className="ms-2" />
                </Button>
              )}
              {phase === phaseList.length - 1 && !disableSale ? (
                <>
                  <Button
                    color="primary"
                    className="float-end"
                    onClick={saveContract}
                    style={{ width: "220px", fontWeight: "bold" }}>
                    {loadingPage || loadingContract ? (
                      <Spinner animation="border" size={"sm"} />
                    ) : (
                      `Submit ${isQuote ? "Quote" : ""}`
                    )}
                  </Button>
                </>
              ) : null}
            </div>
          </Row>
          <Row className="p-1">
            <Col>
              {contractId ? (
                <Button
                  onClick={() => setShowCommentModal(true)}
                  size="sm"
                  className="bg-success border-success float-end mb-2">
                  <FontAwesomeIcon icon="plus" className="me-1" />
                  Add Comment
                </Button>
              ) : null}
              <Table size="sm">
                <tbody>
                  {comments && comments.length ? (
                    _.map(comments, (c) => (
                      <tr key={c.id} className={classnames({ private: c.isPrivate, urgent: c.isUrgent && isCompanyAdmin }, "comment-row")}>
                        <td className="content" dangerouslySetInnerHTML={{ __html: c.dsc }} />
                        <td style={{ width: "180px" }}>{c.createdAtLocalized}</td>
                        <td style={{ width: "200px" }}>{c.userFullName}</td>
                        <td style={{ width: "50px" }}>
                          {(c.userId === currentUser.id || isSystemAdmin) && canManageComments && (
                            <Button
                              color="danger"
                              className="text-light"
                              size="sm"
                              title="Delete"
                              onClick={() => deleteComment(c.id)}>
                              <FontAwesomeIcon icon="times-circle" />
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="muted-text">No Comments have yet been recorded</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommentModal
        ? (<AddCommentModal
            isCompanyUser={ui_helpers.isContextCompanyUser(currentUser, companyId)}
            comment={comment}
            setComment={setComment}
            onClose={() => setShowCommentModal(false)}
            commentPrivate={commentPrivate}
            setCommentPrivate={setCommentPrivate}
            commentUrgent={commentUrgent}
            setCommentUrgent={setCommentUrgent}
            onSubmit={submitComment}
            privateToName="this company"
          />)
        : null
      }
      <Footer />
    </div>
  );
}
